import styled, { CreateStyled } from '@emotion/styled';

export interface LOTheme {
  name: string;
  colors: {
    primary: string;
    lighterPrimary: string;
    error: string;
    white: string;
    black: string;
    orange: string;
  };
}

export const defaultTheme: LOTheme = {
  name: 'default',
  colors: {
    primary: '#007db8',
    lighterPrimary: '#9ad3fd',
    error: '#ce1126',
    white: '#ffffff',
    black: '#333333',
    orange: '#ef9d00',
  },
};

export default styled as CreateStyled<LOTheme>;
